export default {
  OBESE: 'obese',
  SKINNY: 'skinny'
}
